<template>
    <tbody>
        <tr>
            <td>{{ label }}</td>
            <td @click="setOutcome(AnswerOutcomes.OUTCOME_FAILED)" title="Failed">
                <span class="circle" v-if="internalValue.outcome === AnswerOutcomes.OUTCOME_FAILED"></span>
            </td>
            <td @click="setOutcome(AnswerOutcomes.OUTCOME_ADVISORY)" title="Advisory">
                <span class="circle" v-if="internalValue.outcome === AnswerOutcomes.OUTCOME_ADVISORY"></span>
            </td>
            <td @click="setOutcome(AnswerOutcomes.OUTCOME_PASSED)" title="Passed">
                <span class="circle" v-if="internalValue.outcome === AnswerOutcomes.OUTCOME_PASSED"></span>
            </td>
            <td @click="setOutcome(AnswerOutcomes.OUTCOME_SKIPPED)" title="Skipped">
                <span class="circle" v-if="internalValue.outcome === AnswerOutcomes.OUTCOME_SKIPPED"></span>
            </td>
            <td style="padding: 0 1rem">
                <div class="row">
                    <div class="col">
                        <ui-textbox
                            v-model="internalValue.depth_inner"
                            placeholder="0"
                            @input="updated"
                            @keydown="$emit('keydown')"
                            :disabled="entryDisabled"
                        ></ui-textbox>
                        <span style="font-size: 9px;">Inner</span>
                    </div>
                    <div class="col">
                        <ui-textbox
                            v-model="internalValue.depth_centre"
                            placeholder="0"
                            @input="updated"
                            @keydown="$emit('keydown')"
                            :disabled="entryDisabled"
                        ></ui-textbox>
                        <span style="font-size: 9px;">Centre</span>
                    </div>
                    <div class="col">
                        <ui-textbox
                            v-model="internalValue.depth_outer"
                            placeholder="0"
                            @input="updated"
                            @keydown="$emit('keydown')"
                            :disabled="entryDisabled"
                        ></ui-textbox>
                        <span style="font-size: 9px;">Outer</span>
                    </div>
                </div>
            </td>
            <td style="padding: 0 1rem">
                <div class="row">
                    <div class="col">
                        <ui-textbox
                            v-model="internalValue.make"
                            placeholder="Tyre Make"
                            @input="updated"
                            @keyup="$emit('keyup')"
                            :disabled="entryDisabled"
                        ></ui-textbox>
                        <span style="font-size: 9px;">Make</span>
                    </div>
                    <div class="col">
                        <keen-tyre-size-input
                            v-model="internalValue.spec"
                            label=""
                            @input="updated"
                            @keyup="$emit('keyup')"
                            :disabled="entryDisabled"
                        ></keen-tyre-size-input>
                        <span style="font-size: 9px;">Size</span>
                    </div>
                </div>
            </td>
            <td>
                <ui-textbox
                    v-model="internalValue.comments"
                    placeholder="None"
                    @input="updated"
                    @keyup="$emit('keyup')"
                    style="text-align: left;"
                ></ui-textbox>
                <span style="font-size: 9px;">Report &amp; Recommendations</span>
            </td>
        </tr>
    </tbody>
</template>

<script>
import KeenTyreSizeInput from "../forms/controls/KeenTyreSizeInput"
import {AnswerOutcomes} from "../../classes/Api/Inspection";
import {cloneDeep} from "lodash";

export default {
    components: { KeenTyreSizeInput },
    props: {
        label: {
            type: String
        },
        value: {
            type: Object,
            default: {},
            required: true
        }
    },
    created() {
        if (this.value) {
            this.setInternalValue(this.value)
        }
    },
    watch: {
        value: {
            handler(n) {
                this.setInternalValue(n)
            },
            deep: true
        }
    },
    data() {
        return {
            AnswerOutcomes,
            internalValue: {
                outcome: null,
                comments: null,
                depth_outer: null,
                depth_centre: null,
                depth_inner: null,
                make: null,
                spec: null,
            }
        }
    },
    computed: {
        entryDisabled() {
            return this.internalValue.outcome === AnswerOutcomes.OUTCOME_SKIPPED
        }
    },
    methods: {
        setInternalValue(value) {
            this.$set(this, 'internalValue', cloneDeep(value))
        },
        setOutcome(outcome) {
            this.internalValue.outcome = outcome

            this.updated()
        },
        updated() {
            this.$emit('input', this.internalValue)
        }
    }
}
</script>

<style>
    /* @todo Should be scoped... */
    .circle { width: 10px; height: 10px; border-radius: 50%; background: #212529; display: block; margin: auto; }
</style>